
import { computed, defineComponent } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default defineComponent({
  name: "view-actions",
  props: {
    routeName: String,
    routeNameEdit: String,
  },
  components: {},
  setup() {
    const store = useStore();
    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    const currentApplication = computed(() => {
      return store.getters.currentApplication !== null
        ? store.getters.currentApplication.data
        : {};
    });

    const IsIrbChair = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("irbchair") !== -1) {
        return "Yes";
      }
      return "No";
    });

    const IsFaculty = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("faculty") !== -1) {
        return "Yes";
      }
      return "No";
    });

    const IsIrbMember = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("irbmember") !== -1) {
        return "Yes";
      }
      return "No";
    });

    const route = useRoute();

    const currentId = computed(() => {
      return route.params.id;
    });

    return {
      currentId,
      IsFaculty,
      IsIrbChair,
      currentApplication,
    };
  },
});
